import axios from 'axios';
import React, { Component } from 'react';
import moment from 'moment';
import { Link, withRouter } from "react-router-dom";
import {
    Paper,
    Button,
    Avatar,
    CardHeader,
    Table,
    TableRow,
    TableHead,
    TableCell,
    TableBody,
    CircularProgress
} from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { getOffSetTime, ROLE_CUSTOMER, SERVER_URL } from '../../utils/config/constants.js';
import * as actions from '../../actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { validateNonEmpty, validateNonEmptyRecurrance } from '../../utils/validators/validateForm.js';
import { NotificationManager } from 'react-notifications';
// import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import AddWalletMoney from '../Customer/AddWalletMoney.jsx';
import { getCookies } from '../../utils/getToken.js';
class ConfirmedData extends Component {
    state = {
        selectedPackage: {},
        loaderButton: false,
        redirectBookingDashboard: false,
        redirectCardPayment: false,
        bookingId: '',
        cardlastno: '',
        showAddWalletOption: false,
        hourlyServiceData: [],
        packageServiceData: [],
        serviceDetailData: [],
        createBookingServices: [],
        cardPayAmount: "",
        card_payment_detail: [],
        rejected_services: [],
        hourly_booked_services: [],
        package_booked_services: [],
        redirectBookingStatus: false,
        bookingDetails: [],
        headingTitle: '',
        isChecked: false,



    };

    componentDidMount() {
        this.preBookingDetail()

    }
    renderCmsDetail = slug => {
        this.props.history.push(`/page/${slug}`);
    };
    preBookingDetail = () => {

        var authToken = getCookies();
        axios({
            method: 'post',
            url: `${SERVER_URL}/booking/prebooking`,
            data: {
                services: this.props.serviceData
            },
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == "OK") {

                console.log("PreBooking Dataaaaa22:::", resJson.data.data)
                this.setState({
                    hourlyServiceData: resJson.data.data.hourly_services,
                    packageServiceData: resJson.data.data.package_services,
                    serviceDetailData: resJson.data,
                    createBookingServices: resJson.data.data.services
                })
            } else {
                NotificationManager.error("Oops!", resJson.data.message)
            }
        })

    }


    payViaCard = () => {
        const { selectedCard } = this.props

        this.props.payViaCardAction(

            {
                cardId: selectedCard == undefined ? "" : selectedCard.id,
                bookingToken: this.state.bookingId == "" ?
                    "" : this.state.bookingDetails.token,
                rejected_services: this.state.rejected_services,
                card_payment_detail: this.state.card_payment_detail,
                hourly_booked_services: this.state.hourly_booked_services,
                package_booked_services: this.state.package_booked_services
            },
            this.onPaymentDone,
        );
    };
    onPaymentDone = (success, data) => {

        if (success) {
            NotificationManager.success(data.message, 'Success');
            this.setState({
                redirectBookingStatus: true,
                rejected_services: data.data.rejected_services,
                card_payment_detail: data.data.card_payment_detail,
                hourly_booked_services: data.data.hourly_booked_services,
                package_booked_services: data.data.package_booked_services,
            });
        } else {
            NotificationManager.error(data.message, 'Oops!');
        }
    };



    renderButton = () => {
        if (this.state.loaderButton) {
            return (
                <div className="text-center mt-2">
                    <CircularProgress />
                </div>
            );
        } else {
            return (



                <div className="text-center mt-3 mb-3">
                    <div className="check_div">
                        <div className="form-group">
                            <div className="form-check">
                                <input onChange={() => this.toggleChange()} className="form-check-input" type="checkbox" id="gridCheck" name="gridCheck" />
                                <label className="form-check-label" for="gridCheck">
                                    I understand that I am purchasing a service subject to eZpro's <Link to={'/page/terms-and-conditions'}>Term of Use</Link >  and <Link to={'/page/privacy-policy'}> Cancellation policy </Link>my payment method will be charged before the service.
                                </label>
                            </div>
                        </div>
                    </div>
                    {this.props.userData.role == ROLE_CUSTOMER && (
                        <button
                            className="custom-button bookbtn"
                            onClick={() => this.createBooking()}
                        >
                            <FormattedMessage
                                id="booking.book"
                                defaultMessage="Book"
                            />
                        </button>
                    )}

                </div>
            );
        }
    };
    toggleChange = () => {

        if (this.state.isChecked == false || this.state.isChecked == '') {


            this.setState({
                isChecked: true

            });
            console.log("hhhd", this.state.isChecked)


        } else if (this.state.isChecked == true) {
            this.setState({
                isChecked: false

            });
            console.log("hhhd", this.state.isChecked)
        }

        

    }


    createBooking = () => {

        console.log("card", this.props.cardlastno);
        if (this.state.isChecked == true) {
            console.log('hh', this.state.isChecked)
            console.log("data waleee data:::::", this.props.data)

            console.log("booking props:::::", this.props.showRecurrinOptions, this.props.recurringValue, this.props.atHomeValue, this.props.additionalTextValue, this.props.imageFiles)


            const { selectedPromoCode } = this.props;

            var address_id = '';
            if (this.props.settings.constants.serviceAssignment == "user") {
                address_id = this.props.data.displayAddress.id;

            } else {
                address_id = "caaccaadacaacacsa";

            }

            if (this.props.paymentType == 3 && this.props.packageItem != null) {
                if (this.props.userData.wallet < this.props.packageItem.price) {
                    NotificationManager.error(
                        <FormattedMessage
                            id="walletBalanceLow"
                            defaultMessage="Your wallet balance is low, please recharge"
                        />
                    );
                    this.props.showAddFundOption();
                } else {

                    if (
                        this.checkBookingData(
                            
                            {
                                addressId: this.props.selectedAddress.key,
                                paymentType: this.props.paymentType,
                                bookingDate: this.props.bookingDate,
                                bookingTime: this.props.bookingTime.start,
                                packageItem: this.props.packageItem
                                    ? this.props.packageItem.key
                                    : null,
                                providerId: this.props.data.id,
                                serviceId: this.props.data.proServiceId,
                                providerAddressId: address_id,
                                recurrance_period: this.props.recurring_type_id,
                                is_recurring: this.props.is_recurring,
                                at_home: this.props.atHomeValue,
                                service_id: this.props.serviceId,
                                for_future: this.props.bookingValue,
                                lock_box: this.props.additionalTextValue,
                                images: this.props.imageFiles
                            },
                            this.handleError
                        )
                    ) {
                        this.setState({ loaderButton: true });
                        this.props.createBookingAction(
                            {
                                note: this.props.additionalNotes,
                                promoCode: {
                                    code: selectedPromoCode.code,
                                    id: selectedPromoCode.key
                                },
                                customerAddressId: this.props.selectedAddress.key,
                                paymentType: this.props.paymentType,
                                date: this.props.bookingDate,
                                time: getOffSetTime(this.props.bookingTime.start),
                                proPackageId: this.props.packageItem
                                    ? [this.props.packageItem.key]
                                    : [],
                                providerId: this.props.data.id,
                                proServiceId: this.props.data.proServiceId,
                                providerAddressId: address_id,
                                recurrance_period: this.props.recurring_type_id,
                                is_recurring: this.props.is_recurring,
                                at_home: this.props.atHomeValue,
                                service_id: this.props.serviceId,
                                for_future: this.props.bookingValue,
                                lock_box: this.props.additionalTextValue,
                                images: this.props.imageFiles,
                                services: this.state.createBookingServices,
                                card_no_four_digit: this.props.paymentType == 2 ? this.props.cardlastno : ''

                            },
                            this.onBookingDone
                        );
                    }
                }
            } else {
                if (
                    this.checkBookingData(
                        {
                            addressId: this.props.selectedAddress.key,
                            paymentType: this.props.paymentType,
                            bookingDate: this.props.bookingDate,
                            bookingTime: this.props.bookingTime.start,
                            packageItem: this.props.packageItem
                                ? this.props.packageItem.key
                                : null,
                            providerId: this.props.data.id,
                            serviceId: this.props.data.proServiceId,
                            providerAddressId: address_id,
                            recurrance_period: this.props.recurring_type_id,
                            is_recurring: this.props.is_recurring,
                            at_home: this.props.atHomeValue,
                            service_id: this.props.serviceId,
                            for_future: this.props.bookingValue,
                            lock_box: this.props.additionalTextValue,
                            images: this.props.imageFiles,

                        },
                        this.handleError
                    )
                ) {
                    this.setState({ loaderButton: true });
                    this.props.createBookingAction(
                        {
                            note: this.props.additionalNotes,
                            promoCode: {
                                code: selectedPromoCode.code,
                                id: selectedPromoCode.key
                            },
                            customerAddressId: this.props.selectedAddress.key,
                            paymentType: this.props.paymentType,
                            date: this.props.bookingDate,
                            time: getOffSetTime(this.props.bookingTime.start),
                            proPackageId: this.props.packageItem
                                ? [this.props.packageItem.key]
                                : [],
                            providerId: this.props.data.id,
                            proServiceId: this.props.data.proServiceId,
                            providerAddressId: address_id,
                            recurrance_period: this.props.recurring_type_id,
                            is_recurring: this.props.is_recurring,
                            at_home: this.props.atHomeValue,
                            service_id: this.props.serviceId,
                            for_future: this.props.bookingValue,
                            lock_box: this.props.additionalTextValue,
                            images: this.props.imageFiles,
                            services: this.state.createBookingServices,
                            card_no_four_digit: this.props.paymentType == 2 ? this.props.cardlastno : ''

                        },
                        this.onBookingDone
                    );
                }
            }

        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="bookingCancelledSuccessdddd"
                    defaultMessage="Please accept Term of Use and  Cancellation policy"
                />
            );
        }

    };

    onBookingDone = (success, data) => {
        console.log("After Booking Create Dataa::::::", data)
        if (success) {
            NotificationManager.success(data.message, 'Booking Initiated');
            if (!data.card_payment_take) {
                this.setState({
                    loaderButton: false,
                    redirectBookingStatus: true,
                    rejected_services: data.data.rejected_services,
                    card_payment_detail: data.data.card_payment_detail,
                    hourly_booked_services: data.data.hourly_booked_services,
                    package_booked_services: data.data.package_booked_services
                });
            } else if (data.card_payment_take) {
                this.setState({
                    loaderButton: false,
                    bookingDetails: data,
                    redirectCardPayment: false,
                    cardPayAmount: data.card_payment_amount,
                    rejected_services: data.data.rejected_services,
                    card_payment_detail: data.data.card_payment_detail,
                    hourly_booked_services: data.data.hourly_booked_services,
                    package_booked_services: data.data.package_booked_services
                }, this.payViaCard);
            } else if (data.data.details.payment_type == 3) {
                this.setState({
                    loaderButton: false,
                    redirectBookingDashboard: true,
                    bookingId: data.data.key
                });
            } else if (data.data.details.payment_type == 4) {
                this.setState({
                    loaderButton: false,
                    redirectPayfastPayment: true,
                    bookingId: data.data.key
                });
            } else if (data.data.details.payment_type == 5) {
                this.setState({
                    loaderButton: false,
                    redirectPaypalPayment: true,
                    bookingId: data.data.key
                });
            }
        } else if (data.status == "NOK") {
            this.setState({
                loaderButton: false, redirectBookingStatus: true,
                rejected_services: data.data.rejected_services,
                card_payment_detail: data.data.card_payment_detail,
                hourly_booked_services: data.data.hourly_booked_services,
                package_booked_services: data.data.package_booked_services
            });
            NotificationManager.error(data.message, 'Error');
        }
    };
    checkBookingData = (
        {
            addressId,
            paymentType,
            bookingDate,
            bookingTime,
            packageItem,
            providerId,
            serviceId,
            providerAddressId,
            recurrance_period,
            is_recurring,
            at_home,
            lock_box
        },
        done
    ) => {
        console.log("Payment Type:::", !validateNonEmpty(paymentType), this.state.packageServiceData.length == 0)
        let validation = true;
        if (!validateNonEmpty(addressId)) {
            validation = false;
            done('Customer Address is required');
        }
        if (!validateNonEmpty(paymentType)) {
            validation = false;
            done('Please Choose atleast one payment method');
        }
        if (paymentType == 1 && this.state.packageServiceData.length > 0) {
            validation = false;
            done('Please Choose atleast one payment method');
        }
        if (!validateNonEmpty(bookingDate)) {
            validation = false;
            console.log("baaa", bookingDate)
            done('Select a Booking Date atleast');
        }
        if (!validateNonEmpty(bookingTime)) {
            validation = false;
            done('Select a date with Available time slot');
        }
        if (!validateNonEmpty(providerId) && this.props.settings.constants.serviceAssignment == 'user') {
            validation = false;
            done('Select provider profile to book a service');
        }
        if (!validateNonEmpty(providerAddressId) && this.props.settings.constants.serviceAssignment == 'user') {
            validation = false;
            done('Provider Address is empty');
        }
        if (packageItem) {
            if (!validateNonEmpty(packageItem)) {
                validation = false;
                done('Package is not selected');
            }
        }
        if (serviceId) {
            if (!validateNonEmpty(serviceId)) {
                validation = false;
                done('Select a service to book');
            }
        }
        if (is_recurring && !validateNonEmptyRecurrance(recurrance_period)) {
            validation = false;
            done('Select Recurrance Period')
        }
        if (!at_home && !validateNonEmpty(lock_box)) {
            validation = false;
            done('Enter Lock-Box Info')
        }
        // if (this.props.cardlastno == undefined) {
        //     NotificationManager.error(
        //         <FormattedMessage
        //             id="Card"
        //             defaultMessage="Please add Card First"
        //         />
        //     );
        // } else {
        //     console.log("card confirm", this.props.cardlastno);
        // }
        if ( paymentType == "2" && this.props.cardlastno == undefined || this.props.cardlastno == ""){
            NotificationManager.error(
                        <FormattedMessage
                            id="Card"
                            defaultMessage="No Card Added!"
                        />
                    );
                    validation = false;
        }

        return validation;
    };

    handleError = error => {
        if (error) {
            NotificationManager.error(error, 'Error');
        }
    };
    render() {

        const {
            hourlyServiceData, packageServiceData, serviceDetailData
        } = this.state;


        console.log("service name:::::::", this.state.serviceDetailData)

        const {
            data,
            selectedAddress,
            bookingTime,
            bookingDate,
            selectedPromoCode,
            additionalNotes,
            isService,
            packageItem,
            finalAmount,
            bookingValue,
            recurrance_period,
            is_recurring,
           
        } = this.props;
        if (this.state.redirectBookingDashboard) {
            this.props.history.push({
                pathname: `/user/booking/detail/${this.state.bookingId}`,
                bookingId: this.state.bookingId
            });
        }
        if (this.state.redirectBookingStatus) {
            this.props.history.push({
                pathname: `/booking/status/`,
                state: {
                    rejected_services: this.state.rejected_services,
                    card_payment_detail: this.state.card_payment_detail,
                    hourly_booked_services: this.state.hourly_booked_services,
                    package_booked_services: this.state.package_booked_services
                }
            });
        }

        if (this.state.redirectCardPayment) {
            console.log("go to payment fields::::", this.state.rejected_services, this.state.card_payment_detail,
                this.state.hourly_booked_services, this.state.package_booked_services)
            this.props.history.push({
                pathname: `/booking/payment/`,
                state: {
                    cardPayAmount: this.state.cardPayAmount,
                    rejected_services: this.state.rejected_services,
                    card_payment_detail: this.state.card_payment_detail,
                    hourly_booked_services: this.state.hourly_booked_services,
                    package_booked_services: this.state.package_booked_services,
                    fromBookingDetail: false
                }
            });

        }

        if (this.state.redirectPayfastPayment) {
            this.props.history.push({
                pathname: `/booking/payfastpayment/${this.state.bookingId}`
            });
            // return (
            //     <Redirect
            //         to={{
            //             pathname: `/booking/payfastpayment/${
            //                 this.state.bookingId
            //             }`
            //         }}
            //     />
            // );
        }
        return (
            <div className="col-md-12 main-panel confirm-book-side">
                {this.props.settings.constants.serviceAssignment == "user" ? <div>
                    <h4>
                        <b>
                            <FormattedMessage
                                id="booking.provider"
                                defaultMessage="Provider"
                            />
                        </b>
                        {data.proImage && (
                            <CardHeader
                                className="pl-0 pr-0"
                                avatar={<Avatar src={data.proImage.small} />}
                                title={data.businessName}
                                subheader={data.tagline}
                            />
                        )}
                    </h4>
                </div> : null}
                <Paper elevation={2} style={{ paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10 }}>
                    <h4>
                        <b>
                            <FormattedMessage
                                id="booking.service"
                                defaultMessage="Service"
                            />
                        </b>
                    </h4>
                    {this.state.packageServiceData.length > 0 && (
                        <Paper elevation={2} style={{ paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10, marginBottom: 5 }}>

                            <h5>
                                <b>
                                    Fixed Price Services

                                </b>
                            </h5>
                            <div className="tz-db-table mb-4">
                                <Table className="bordered">

                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <p>Category</p>
                                            </TableCell>
                                            <TableCell>
                                                <p>Service</p>
                                            </TableCell>
                                            {/* <TableCell>
                                                <p>Price</p>
                                            </TableCell> */}
                                        </TableRow>

                                    </TableHead>
                                    {packageServiceData.map((item, index) => {
                                        console.log("Fixed Price Services", item.full_name.master_category)
                                        return (
                                            <TableBody>

                                                <TableRow>
                                                    <TableCell>
                                                        <p>{item.full_name.master_category}</p>

                                                    </TableCell>
                                                    <TableCell>
                                                        <p>{item.full_name.category}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    })}

                                </Table>
                            </div>
                            <div className="tz-db-table mb-4">
                                <Table className="bordered">

                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <p>Task</p>
                                            </TableCell>
                                            <TableCell>
                                                <p>Quantity</p>
                                            </TableCell>
                                            <TableCell>
                                                <p>Price</p>
                                            </TableCell>
                                        </TableRow>

                                    </TableHead>
                                    {packageServiceData.map((item, index) => {
                                        return (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <p>{item.name}</p>
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>
                                                        <p>x {item.qty}</p>
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>
                                                        <p> ${bookingValue ? item.price : item.rush_hr_price}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    })}

                                </Table>
                            </div>
                        </Paper>)
                    }
                    {this.state.hourlyServiceData.length > 0 && (
                        <Paper elevation={2} style={{ paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10, marginBottom: 5 }}>
                            <h5>
                                <b>
                                    Hourly Services
                                </b>
                            </h5>
                            <div className="tz-db-table mb-4">
                                <Table className="bordered">

                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <h5>Categorie</h5>
                                            </TableCell>
                                            <TableCell>
                                                <h5>Service</h5>
                                            </TableCell>
                                            {/* <TableCell>
                                                <p>Price</p>
                                            </TableCell> */}
                                        </TableRow>

                                    </TableHead>
                                    {hourlyServiceData.map((item, index) => {
                                        console.log(" Hourly Services", item.full_name.master_category)
                                        return (
                                            <TableBody>

                                                <TableRow>
                                                    <TableCell>
                                                        <p>{item.full_name.master_category}</p>

                                                    </TableCell>
                                                    <TableCell>
                                                        <p>{item.full_name.category}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    })}

                                </Table>
                            </div>
                            <div className="tz-db-table mb-4">
                                <Table className="bordered">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <p>Task</p>
                                            </TableCell>
                                            <TableCell>
                                                <p>Quantity</p>
                                            </TableCell>
                                            <TableCell>
                                                <p>Price</p>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {hourlyServiceData.map((item, index) => {
                                        // console.log("matrehs dbvbdv" ,item.full_name.master_category)
                                        return (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <p>{this.props.settings.constants.serviceAssignment == "user" ?
                                                            this.props.data.serviceName : item.name}</p>
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>
                                                        <p>x {item.qty}</p>
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>
                                                        <p>$ {this.props.settings.constants.serviceAssignment == "user" ? this.props.data.servicePrice :
                                                            !bookingValue ? item.rush_hr_price :
                                                                item.price}
                                                            /
                                                            <FormattedMessage
                                                                id="hour"
                                                                defaultMessage="hour"
                                                            />
                                                        </p>
                                                    </TableCell>
                                                </TableRow>

                                            </TableBody>
                                        )
                                    })}

                                </Table>
                            </div>
                        </Paper>
                    )}


                    <h4 className="mt-3">
                        <b>
                            <FormattedMessage
                                id="Total"
                                defaultMessage="Total"
                            />
                        </b>
                    </h4>
                    <Paper elevation={2} style={{ paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10, marginBottom: 5 }}>

                        <h5>
                            <b>
                                Total pay amount
                            </b>
                        </h5>
                        {serviceDetailData.summary && <div className="tz-db-table mb-4">
                            <Table className="bordered">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <p>Total quantity</p>
                                        </TableCell>
                                        <TableCell>
                                            <p>Total price</p>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    <TableRow>
                                        <TableCell style={{ textAlign: "center" }}>
                                            <p>{serviceDetailData.summary.total_qty}</p>
                                        </TableCell>
                                        <TableCell style={{ textAlign: "center" }}>
                                            <p>$ {bookingValue ? serviceDetailData.summary.total_price : serviceDetailData.summary.total_rush_hr_price}</p>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>}
                    </Paper>
                </Paper>
                {bookingDate && (
                    <Paper elevation={2} style={{ padding: 10, marginTop: 20 }}>

                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.date"
                                    defaultMessage="Date"
                                />
                            </b>
                            <p>
                                {moment(bookingDate).format('MM-DD-YYYY')}</p>

                        </h4>
                    </Paper>
                )}
                {bookingTime && (
                    <Paper elevation={2} style={{ padding: 10, marginTop: 20 }}>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.time"
                                    defaultMessage="Time"
                                />
                            </b>
                            <p className="time_date" style={{ textTransform: "uppercase" }}>{bookingTime.label}</p>
                        </h4>
                    </Paper>
                )}


                      {is_recurring && (
                    <Paper elevation={2} style={{ padding: 10, marginTop: 20 }}>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="Recurring Job Type"
                                    defaultMessage="Recurring Job Type"
                                />
                            </b>
                            <p className="RECURRING-JOB" style={{ textTransform: "uppercase" }}>


                                {this.props.recurring_type_id == 7 ? "Weekly" : this.props.recurring_type_id == 15 ? "Every 2 Weeks" :
                                                            this.props.recurring_type_id == 30 ? "Monthly" : this.props.recurring_type_id == 365 ? "Yearly" : this.props.recurring_type_id == 180
                                                                ? "Bi-Annual" : this.props.recurring_type_id}
                            {console.log("kapil" ,this.props.recurring_type_id)}</p>
                        </h4>
                    </Paper>
                )}


                {selectedAddress && (
                    <Paper elevation={2} style={{ padding: 10, marginTop: 20 }}>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.billingaddress"
                                    defaultMessage="Booking and Billing Address"
                                />
                            </b>
                        </h4>
                        <p>
                            <b> {selectedAddress.name}</b> <br />
                            <b>
                                <FormattedMessage
                                    id="booking.phone"
                                    defaultMessage="Phone"
                                />
                                {"   "}:
                            </b>
                            {"   "}{selectedAddress.phone} <br />
                            <b>
                                <FormattedMessage
                                    id="booking.email"
                                    defaultMessage="Email"
                                />
                                {"   "}:
                            </b>
                            {"   "}{selectedAddress.email} <br />
                            <b>
                                <FormattedMessage
                                    id="booking.address"
                                    defaultMessage="Address"
                                />
                                {"   "}:
                            </b>
                            {"   "}{selectedAddress.address_line1}
                        </p>
                    </Paper>
                )}

                {selectedPromoCode && (
                    <Paper elevation={2} style={{ padding: 10, marginTop: 20 }}>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.promo"
                                    defaultMessage="Promo Code"
                                />
                            </b>
                        </h4>
                        <Button variant="outlined" color="primary">
                            {selectedPromoCode.code}
                        </Button>
                    </Paper>
                )}

                {this.state.redirectWalletPayment && <AddWalletMoney />}

                {additionalNotes && (
                    <Paper elevation={2} style={{ padding: 10, marginTop: 20 }}>
                        <h4>
                            <b>
                                <FormattedMessage
                                    id="booking.notes"
                                    defaultMessage="Additional Notes"
                                />
                            </b>
                        </h4>
                        <p>{additionalNotes}</p>
                    </Paper>
                )}

                <div className=" mb-2">{this.renderButton()}</div>
            </div>
        );
    }
}



const mapStateToProps = ({ settings, auth }) => {
    return {
        settings: settings,
        userData: auth.userData
    };
};

const composedComponent = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    )
);

export default composedComponent(withUser(withRouter(ConfirmedData)));


// WEBPACK FOOTER //
// ./src/components/Booking/ConfirmedData.jsx